// react-bootstrap imports
import Stack from "react-bootstrap/Stack"
import "bootstrap/dist/css/bootstrap.min.css"

// css imports
import "App.css"

// components imports
import Header from "components/Header"
import Footer from "components/Footer"
import Lua from "components/Lua"
import VLibras from "@djpfs/react-vlibras"
import Routes from "Routes"

export default function App()
{
    return (
        <Stack direction="vertical" className="bg-light text-dark d-flex flex-column min-vh-100">
            <VLibras />
            <Header />
            <Routes />
            <Lua />
            <Footer />
        </Stack>
    )
}